const MAX_RELOADS_COUNT = 3;
const RELOAD_COUNT_KEY = 'reload_count';

export const doSmthOnRenderError = () => {
  const currentCount = parseInt(localStorage.getItem(RELOAD_COUNT_KEY) || '0');
  if (!navigator.onLine) {
    /**
     * Навигейт на главную чтобы сервис-воркер обнаружил запрос на html
     * и подставил оффлайн-страницу
     */
    window.location.href = window.origin;
  } else {
    if (currentCount < MAX_RELOADS_COUNT) {
      localStorage.setItem(RELOAD_COUNT_KEY, (currentCount + 1).toString());
      window.location.reload();
      return;
    } else {
      localStorage.removeItem(RELOAD_COUNT_KEY);
      return;
    }
  }
};
